// import React from 'react';
// import { Avatar, Popover, Space } from 'antd';
// import { AntDesignOutlined, BellFilled, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
// import Title from 'antd/es/typography/Title';

// const HeaderBar = ({ collapsed, toggleSidebar, userData }) => {
//     return (
//         <header style={{ height: "50px", display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 16px', backgroundColor: '#fff', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//                 <div
//                     style={{
//                         fontSize: '18px',
//                         marginRight: '16px',
//                         cursor: 'pointer',
//                         color: 'black',
//                     }}
//                     onClick={toggleSidebar}
//                 >
//                     {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
//                 </div>
//                 <Title level={4} style={{ color: 'black', margin: 0 }}>
//                     SHAHI EXPORTS PVT. LTD, UNIT-42
//                 </Title>
//             </div>
//             <Space style={{ margin: '0.8rem' }}>
//                 <BellFilled size="large" style={{ fontSize: '20px', color: 'black', marginRight: '15px' }} />

//                 <Popover placement="bottomRight"
//                     title={userData.full_name}
//                     content={
//                         <>
//                             <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
//                                 <span>User Id</span>
//                                 <strong>{userData.su_id}</strong>
//                             </div>
//                             <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                 <span>Username</span>
//                                 <strong>{userData.username}</strong>
//                             </div>
//                         </>
//                     }>
//                     <Avatar
//                         size="small"
//                         icon={<AntDesignOutlined />}
//                     />
//                 </Popover>

//             </Space>
//         </header>
//     );
// };

// export default HeaderBar;
import React, { useState, useEffect } from 'react';
import { Avatar, Popover, Space } from 'antd';
import { AntDesignOutlined, BellFilled, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';

const HeaderBar = ({ collapsed, toggleSidebar, userData }) => {
  const [siteTitle, setSiteTitle] = useState('SHAHI EXPORTS PVT. LTD, UNIT-42'); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSiteTitle = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://unit26.ekanban-unit20.in/index.php/Apiv6/get_site_title', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (data.status && data.title) {
          setSiteTitle(data.title); 
        } else {
          throw new Error(data.message || 'Invalid response format');
        }
      } catch (err) {
        console.error('Error fetching site title:', err);
        setError('Failed to load site title');
        
      } finally {
        setLoading(false);
      }
    };

    fetchSiteTitle();
  }, []); 
  return (
    <header style={{ height: "50px", display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 16px', backgroundColor: '#fff', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            fontSize: '18px',
            marginRight: '16px',
            cursor: 'pointer',
            color: 'black',
          }}
          onClick={toggleSidebar}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </div>
        <Title level={4} style={{ color: 'black', margin: 0 }}>
          {loading ? 'Loading...' : error ? siteTitle : siteTitle}
        </Title>
      </div>
      <Space style={{ margin: '0.8rem' }}>
        <BellFilled size="large" style={{ fontSize: '20px', color: 'black', marginRight: '15px' }} />
        <Popover
          placement="bottomRight"
          title={userData.full_name}
          content={
            <>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                <span>User Id</span>
                <strong>{userData.su_id}</strong>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Username</span>
                <strong>{userData.username}</strong>
              </div>
            </>
          }
        >
          <Avatar
            size="small"
            icon={<AntDesignOutlined />}
          />
        </Popover>
      </Space>
    </header>
  );
};

export default HeaderBar;
